<div class="label" (click)="open(!opened())">
	<label>{{ label() }}</label>
	@if (showSearchIcon()) {
		<app-icon name="search" size="small" color="background-2" hoverColor="typography-5" (click)="toggleSearch($event)"></app-icon>
	}
	@if (canErase$ | async) {
		<app-icon name="sluiten" size="small" color="background-2" hoverColor="typography-5" (click)="erase($event)"></app-icon>
	}
	<app-icon [name]="opened() ? 'chevron-down' : 'chevron-left'" size="smallest" color="typography-5"></app-icon>
</div>
@if (opened() || valueString) {
	<div class="extra">
		@if (opened()) {
			<ng-template
				appFilterInput
				[filterName]="filterName()"
				[searchInput]="searchActivated() ? searchInput() : undefined"
				(searchInputChange)="searchInput.set($event)"
			>
			</ng-template>
		} @else if (valueString) {
			<div class="value" (click)="open(true)">{{ valueString }}</div>
		}
	</div>
}
